module.exports = __webpack_public_path__ + "static/img/banner_1.0625351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thirdAnniversary/3/banner_1.png
// module id = 37ss
// module chunks = 2